import { default as domainCampus } from './campus/store'
import { default as domainCompanyBranch } from './branch/store'
import { default as domainCompany } from './company/store'
import { default as domainEducationalGroup } from './educacional-group/store'
import { default as domainInstitution } from './institution/store'

export default {
    domainCampus,
    domainCompanyBranch,
    domainCompany,
    domainInstitution,
    domainEducationalGroup
}